import { render, staticRenderFns } from "./AbaEditarDadosIniciaisDi.vue?vue&type=template&id=3b7a54ce"
import script from "./AbaEditarDadosIniciaisDi.vue?vue&type=script&lang=ts"
export * from "./AbaEditarDadosIniciaisDi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports